import React from 'react';
import { Users } from 'lucide-react';
import { getRoleColor, getRoleDisplayName } from '../../utils/chatUtils';

const StakeholdersList = ({ stakeholders = [], isOpen, onToggle }) => {
  return (
    <div className="relative">
      <button
        onClick={onToggle}
        className="flex items-center space-x-1 px-2 py-1 text-xs text-white hover:bg-blue-600 rounded transition-colors duration-200"
      >
        <Users size={12} />
        <span>{stakeholders.length}</span>
      </button>
      
      {isOpen && (
        <div className="absolute top-full right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 min-w-[250px] max-h-[300px] overflow-y-auto">
          <div className="p-3 border-b border-gray-200">
            <h3 className="font-medium text-gray-800">Event Participants</h3>
          </div>
          <div className="p-2">
            {stakeholders.length === 0 ? (
              <p className="text-sm text-gray-500 text-center py-4">
                No participants found
              </p>
            ) : (
              stakeholders.map((stakeholder, index) => (
                <div key={index} className="flex items-center space-x-3 p-2 hover:bg-gray-50 rounded-lg">
                  <div 
                    className="w-3 h-3 rounded-full flex-shrink-0" 
                    style={{ backgroundColor: getRoleColor(stakeholder.role) }}
                  ></div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-800 truncate">
                      {stakeholder.name || stakeholder.username || 'Unknown User'}
                    </p>
                    <p className="text-xs text-gray-500">
                      {getRoleDisplayName(stakeholder.role)}
                    </p>
                  </div>
                  {stakeholder.is_online && (
                    <div className="w-2 h-2 bg-green-400 rounded-full flex-shrink-0"></div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      )}
      
      {/* Close dropdown on outside click */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-10" 
          onClick={onToggle}
        />
      )}
    </div>
  );
};

export default StakeholdersList;
